import "./ReviewsHeading.css"

function ReviewsHeading()
{
    return(
        <h1 className="ReviewsHeadingcontainer">Reviews</h1>
    )
}

export default ReviewsHeading